import React, { useState } from "react";
import {
  Box,
  IconButton,
  InputBase,
  List,
  ListItem,
  Paper,
  useTheme,
} from "@mui/material";
import { FaSearchLocation } from "react-icons/fa";
import PlanoModal from "./PlanoModal";
import PlanoTypography from "./PlanoTypography";
import PlanoButton from "./PlanoButton";

const ModalPopupOnSelect = ({
  open = false,
  setOpen = () => {},
  onClickYes = () => {},
  onClickNo = () => {},
  mainfunction,
  data,
}) => {
  const handleYes = () => {
    setOpen(false);
    onClickYes(data);
  };

  const handleNo = () => {
    setOpen(false);
    onClickNo();
  };
  return (
    <PlanoModal
      title={
        data?.actv_flag !== "Y"
          ? `${data?.loc + " : " + data?.loc_name} is not active for Plano`
          : `Do you want to Switch to ${data?.loc_name} Store`
      }
      open={open}
      size={"sm"}
      showFooter={false}
      setOpen={setOpen}
    >
      <Box display={"flex"} gap={2} justifyContent={"center"}>
        {data?.actv_flag === "Y" ? (
          <>
            <PlanoButton mainfunction={handleYes}>Yes</PlanoButton>
            <PlanoButton mainfunction={handleNo}>No</PlanoButton>
          </>
        ) : (
          <></>
        )}
      </Box>
    </PlanoModal>
  );
};
const PlanoSearchInput = ({ onChange, onClick, value, data, onClickNo }) => {
  const theme = useTheme();
  const [modalPopUp, setModalPopup] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const handleModal = (data) => {
    setSelectedData(data);
    setModalPopup(true);
  };
  return (
    <Paper
      component="form"
      sx={{ p: "2px 4px", display: "flex", alignItems: "center" }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder="Search Location"
        inputProps={{ "aria-label": "search location" }}
        onChange={onChange}
        value={value}
      />
      <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
        <FaSearchLocation color="#f04e23" />
      </IconButton>
      {data.length > 0 && (
        <Paper
          sx={{
            position: "absolute",
            top: `calc(100% + ${theme.spacing(1)})`,
            left: 0,
            width: "100%",
            zIndex: 2,
            height: "350px",
            overflow: "scroll",
          }}
        >
          <List>
            {data?.map((result, index) => (
              <>
                <ListItem
                  onClick={() => handleModal(result)}
                  sx={{
                    backgroundColor: result?.actv_flag !== "Y" && "red",
                    cursor: "pointer",
                  }}
                  key={index}
                >
                  {result?.loc + " : " + result?.loc_name}
                </ListItem>
              </>
            ))}
          </List>
        </Paper>
      )}
      <ModalPopupOnSelect
        open={modalPopUp}
        mainfunction={onClick}
        setOpen={setModalPopup}
        data={selectedData}
        onClickNo={onClickNo}
        onClickYes={onClick}
      />
    </Paper>
  );
};

export default PlanoSearchInput;
